import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberCircleFive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 15.5322C11.3137 15.5322 14 12.8459 14 9.53223C14 6.21852 11.3137 3.53223 8 3.53223C4.68629 3.53223 2 6.21852 2 9.53223C2 12.8459 4.68629 15.5322 8 15.5322Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.5 6.78223H6.9875L6.5 9.79473C6.74475 9.55 7.05657 9.38335 7.39603 9.31584C7.73549 9.24833 8.08735 9.283 8.40711 9.41545C8.72687 9.54791 9.00017 9.77222 9.19246 10.06C9.38474 10.3478 9.48737 10.6861 9.48737 11.0322C9.48737 11.3783 9.38474 11.7167 9.19246 12.0045C9.00017 12.2922 8.72687 12.5165 8.40711 12.649C8.08735 12.7815 7.73549 12.8161 7.39603 12.7486C7.05657 12.6811 6.74475 12.5145 6.5 12.2697",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNumberCircleFive;
